<template>
  <div class="vue-csv-uploader">
    <div class="form">
      <md-checkbox
        type="checkbox"
        name="hasHeaders"
        @change="headersChanges()"
        v-model="hasHeaders"
        class="md-primary"
      >The file contains headers</md-checkbox>
      <div class="form-group csv-import-file">
        <md-field>
          <label>CSV file</label>
          <md-file ref="csv" @change="validFileMimeType" name="csv" accept=".csv" />
        </md-field>
        <slot name="error" v-if="showErrorMessage">
          <div class="invalid-feedback d-block">File type is invalid</div>
        </slot>
      </div>
      <div class="form-group" v-if="!sample">
        <slot name="next" :load="load">
          <button
            type="submit"
            :disabled="disabledNextButton"
            :class="buttonClass"
            @click.prevent="load"
          >{{ loadBtnText }}</button>
        </slot>
      </div>
      <div class="vue-csv-uploader-part-two">
        <div class="vue-csv-mapping" v-if="sample">
          <md-table class="u-full-width">
            <md-table-row>
              <md-table-head>Field</md-table-head>
              <md-table-head>Coulmn</md-table-head>
            </md-table-row>
            <md-table-row v-for="{field, key} in fieldsToMap" v-bind:key="key">
              <md-table-cell>{{ key }}</md-table-cell>
              <md-table-cell>
                <md-field>
                  <md-select :name="`csv_uploader_map_${key}`" v-model="map[key]" md-dense>
                    <md-option
                      :id="key"
                      v-for="(column, key) in firstRow"
                      :key="key"
                      :value="key"
                    >{{ column }}</md-option>
                  </md-select>
                </md-field>
              </md-table-cell>
            </md-table-row>
          </md-table>
          <div class="form-group" v-if="url">
            <slot name="submit" :submit="submit">
              <input
                type="submit"
                :class="buttonClass"
                @click.prevent="submit"
                :value="submitBtnText"
              />
            </slot>
          </div>
        </div>
      </div>
      <md-button v-if="false" class="md-raised" :disabled="sample==null" @click="reload">reload</md-button>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import axios from "axios";
import Papa from "papaparse";
export default {
  props: {
    value: Array,
    url: {
      type: String
    },
    mapFields: {
      required: true
    },
    callback: {
      type: Function,
      default: () => ({})
    },
    catch: {
      type: Function,
      default: () => ({})
    },
    finally: {
      type: Function,
      default: () => ({})
    },
    parseConfig: {
      type: Object,
      default() {
        return {};
      }
    },
    headers: {
      default: true
    },
    loadBtnText: {
      type: String,
      default: "Next"
    },
    submitBtnText: {
      type: String,
      default: "Submit"
    },
    tableClass: {
      type: String,
      default: "table"
    },
    checkboxClass: {
      type: String,
      default: "form-check-input"
    },
    buttonClass: {
      type: String,
      default: "btn btn-primary"
    },
    inputClass: {
      type: String,
      default: "form-control-file"
    },
    validation: {
      type: Boolean,
      default: true
    },
    fileMimeTypes: {
      type: Array,
      default: () => {
        return [
          "text/csv",
          "text/x-csv",
          "application/vnd.ms-excel",
          "text/plain"
        ];
      }
    }
  },
  data: () => ({
    form: {
      csv: null
    },
    fieldsToMap: [],
    map: {},
    hasHeaders: true,
    csv: null,
    sample: null,
    isValidFileMimeType: false,
    fileSelected: false
  }),
  created() {
    this.hasHeaders = this.headers;
    if (_.isArray(this.mapFields)) {
      this.fieldsToMap = _.map(this.mapFields, item => {
        return {
          key: item,
          label: item
        };
      });
    } else {
      this.fieldsToMap = _.map(this.mapFields, (label, key) => {
        return {
          key: key,
          label: label
        };
      });
    }
  },
  methods: {
    clearFile() {
      this.sample = null;
      this.csv = null;
      this.form.csv = null;
      this.fileSelected = false;
      this.map = {};
    },
    headersChanges() {
      // eslint-disable-next-line
      console.log("Headervalue changed");
      const _this = this;
      this.form.csv = this.buildMappedCsv();
      this.$emit("input", this.form.csv);
      _this.callback(this.form.csv);
    },
    submit() {
      const _this = this;
      this.form.csv = this.buildMappedCsv();
      this.$emit("input", this.form.csv);
      if (this.url) {
        axios
          .post(this.url, this.form)
          .then(response => {
            _this.callback(response);
          })
          .catch(response => {
            _this.catch(response);
          })
          .finally(response => {
            _this.finally(response);
          });
      } else {
        _this.callback(this.form.csv);
      }
    },
    buildMappedCsv() {
      const _this = this;
      let csv = this.hasHeaders ? _.drop(this.csv) : this.csv;
      return _.map(csv, row => {
        let newRow = {};
        _.forEach(_this.map, (column, field) => {
          _.set(newRow, field, _.get(row, column));
        });
        return newRow;
      });
    },
    validFileMimeType() {
      this.clearFile();
      let file = this.$refs.csv.files;
      if (file) {
        this.fileSelected = true;
        this.isValidFileMimeType = this.validation
          ? this.validateMimeType(file.type)
          : true;
      } else {
        this.isValidFileMimeType = !this.validation;
        this.fileSelected = false;
      }
    },
    validateMimeType(type) {
      return this.fileMimeTypes.indexOf(type) > -1;
    },
    load() {
      const _this = this;
      this.readFile(output => {
        _this.sample = _.get(
          Papa.parse(output, { preview: 2, skipEmptyLines: true }),
          "data"
        );
        _this.csv = _.get(Papa.parse(output, { skipEmptyLines: true }), "data");
      });
    },
    readFile(callback) {
      let file = this.$refs.csv.$refs.inputFile.files[0];
      if (file) {
        let reader = new FileReader();
        reader.readAsText(file, "UTF-8");
        reader.onload = function(evt) {
          callback(evt.target.result);
        };
        reader.onerror = function() {};
      }
    },
    toggleHasHeaders() {
      this.hasHeaders = !this.hasHeaders;
    },
    makeId(id) {
      return `${id}${this._uid}`;
    }
  },
  watch: {
    map: {
      deep: true,
      handler: function(newVal) {
        if (!this.url) {
          let hasAllKeys = Array.isArray(this.mapFields)
            ? _.every(this.mapFields, function(item) {
                return newVal.hasOwnProperty(item);
              })
            : _.every(this.mapFields, function(item, key) {
                return newVal.hasOwnProperty(key);
              });
          if (hasAllKeys) {
            this.submit();
          }
        }
      }
    }
  },
  computed: {
    firstRow() {
      return _.get(this, "sample.0");
    },
    showErrorMessage() {
      return this.fileSelected && !this.isValidFileMimeType;
    },
    disabledNextButton() {
      return !this.isValidFileMimeType;
    }
  }
};
</script>